import React from 'react';
import { BodyText, Dialog, HeadingText, Button } from '@paypalcorp/pp-react';
import { DragDropImage } from './DragDropImage';
import { parseMessages } from '../../utilityHelper';
import { get } from 'lodash';

export const LogoContainer = (props) => {
    const messages = parseMessages('givingfund').profile;
    const onChangeLogo = (logo) => {
        props.setLogo(logo);
    }

    const handleModalClose = () => {
        if (props.logo.openModal) {
            props.setLogo({ src: get(props.charityInfo, 'logo_url', ''), openModal: false });
        }
    }

    return (
        <>
            <Dialog isOpen={props.logo.openModal} hideTitle={true} closeButtonLabel={messages.cancel} onClose={handleModalClose} center={true}>
                <div className="logoHelp">
                    <div className="profileLogo">
                        <div className="logo" style={{ background: '#C4C4C4' }}>
                            <img className="exampleLogo" src="https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom.svg" />
                        </div>
                    </div>
                    <HeadingText className="header" size="sm">{messages.logo.tips.head}</HeadingText>
                    <BodyText className="bodyTxt">
                        {messages.logo.tips.body}
                    </BodyText>
                    <BodyText className="bodyTxt">
                        {messages.logo.tips.subHead}
                        <ul style={{ paddingLeft: '0.875rem' }}>
                            <li>{messages.logo.tips.li1}</li>
                            <li>{messages.logo.tips.li2}</li>
                            <li>{messages.logo.tips.li3}</li>
                        </ul>
                    </BodyText>
                    <HeadingText className="header" size="sm">{messages.logo.dragDrop}</HeadingText>
                    <DragDropImage messages={messages} classes={props.logo.error && 'error'} onChange={onChangeLogo} image={props.logo} />
                    <div>
                        {!props.logo.error && <Button style={{ marginTop: '1.5rem' }} onClick={props.onSave}>{messages.save}</Button>}
                    </div>
                    <div>
                        <Button style={{ marginBottom: '1.5rem' }} tertiary onClick={handleModalClose}>{messages.cancel}</Button>
                    </div>
                </div>
            </Dialog>
            <DragDropImage messages={messages} label={messages.logo.dragDrop} onChange={onChangeLogo} image={props.logo} />
        </>
    )
}